import AppLayout from "layouts/appLayout/AppLayout";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { UserController } from "services/user/UserController";
import { Card } from "stories";
import { useFetchState } from "utils/customHooks/useFetchState";
import { useToast } from "utils/customHooks/useToast";
import Avatar from "./elements/avatar/Avatar";
import ProfileForm from "./elements/profileForm/ProfileForm";
import ProfileInfo from "./elements/profileInfo/ProfileInfo";
import classes from "./Profile.module.scss";

const Profile = () => {
  const [editMode, setEditMode] = useState(false);
  const user = UserController();
  const { showToast } = useToast();
  const [fetchState, sendRequest] = useFetchState();

  useEffect(() => {
    if (!editMode) {
      sendRequest(user.getCurrentUserInfo, null);
    }
  }, [editMode]); // eslint-disable-line

  const requestUpdateAvatar = (avatar) => {
    if (fetchState.data) {
      showToast("Image Updated!", "success");
      const body = {
        avatar,
      };
      user.updateCurrentUserInfo(body);
    }
  };

  return (
    <AppLayout title={"My Profile"} hideSidebar backButton>
      <Helmet>
        <title>Profile | Fundever</title>
      </Helmet>
      <Container fluid>
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <div className={classes["card-wrapper"]}>
              <Card>
                <div className={classes["content-wrapper"]}>
                  <div className={"card-title"}>Complete Your Profile</div>
                  <Avatar
                    filename={fetchState.data?.avatar || ""}
                    requestUpdateAvatar={requestUpdateAvatar}
                  />
                  {editMode ? (
                    <ProfileForm
                      userData={fetchState.data || {}}
                      setEditMode={setEditMode}
                    />
                  ) : (
                    <ProfileInfo
                      getProfileResponse={fetchState.data || {}}
                      setEditMode={setEditMode}
                    />
                  )}
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </AppLayout>
  );
};

export default Profile;
